import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {LABEL_FLOAT, LAYOUT_TYPE_FULL, MINO_STYLE, NAV_STYLE_DRAWER, NAV_STYLE_FIXED, THEME_TYPE_SEMI_DARK} from "constants/ThemeSetting";
import {
    etkinMenuDuzeni,
    gecerliKullaniciId,
    gorunumDogrula,
    gorunumOku,
    GorunumTercihi
} from "../../core/gorunum/gorunumTercihi";

interface themeModel {
    navStyle: string,
    layoutType: string,
    themeType: string,
    themeColor: string,
    isDirectionRTL: boolean
    navCollapsed: boolean,
    width: number,
    labelType:string,
    menuFold: boolean,
    fullScreen:boolean,
    /** kişisel görünüm tercihi (core/gorunum/gorunumTercihi.ts); navStyle ve menuFold buradan türetilir */
    gorunum: GorunumTercihi,
}

/** tercihten türetilen alanlar: kenar çubuğunun daraltma durumu için TEK KAYNAK (tamEkran Aşama 2'de) */
const turetilmis = (gorunum: GorunumTercihi) => {
    const duzen = etkinMenuDuzeni(gorunum);
    return {navStyle: duzen === "gizli" ? NAV_STYLE_DRAWER : NAV_STYLE_FIXED, menuFold: duzen === "dar"};
};

const ilkGorunum = gorunumOku(gecerliKullaniciId());

const initialState:themeModel = {
    navStyle: turetilmis(ilkGorunum).navStyle,
    layoutType: LAYOUT_TYPE_FULL,
    themeType: THEME_TYPE_SEMI_DARK,
    themeColor:MINO_STYLE,
    isDirectionRTL: false,
    // true = çekmece (Drawer) açık: sayfa açılışında KAPALI gelir
    navCollapsed: false,
    width: window.innerWidth,
    // labelType: LABEL_NORMAL
    labelType: LABEL_FLOAT,
    menuFold: turetilmis(ilkGorunum).menuFold,
    fullScreen:false,
    gorunum: ilkGorunum,
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setDirectionRTL: (state, action: PayloadAction<any>) => {
            state.isDirectionRTL = action.payload;
        },
        toggleCollapsedSideNav: (state, action:PayloadAction<boolean>) => {
            state.navCollapsed = action.payload;
        },
        updateWindowWidth: (state, action:PayloadAction<number>) => {
            state.width = action.payload;
        },
        setFullScreen: (state, action:PayloadAction<boolean>) => {
            state.fullScreen = action.payload;
        },
        /** kullanıcının seçimi: verilen alanlar birleştirilir (Görünüm ekranı, kenar çubuğunun daraltma düğmesi) */
        setGorunum: (state, action:PayloadAction<Partial<GorunumTercihi>>) => {
            state.gorunum = gorunumDogrula({...state.gorunum, ...action.payload});
            Object.assign(state, turetilmis(state.gorunum));
        },
        /** tercih TÜMÜYLE değişir: giriş / kullanıcı değişimi, sunucudan ya da başka sekmeden gelen değer */
        gorunumYukle: (state, action:PayloadAction<GorunumTercihi>) => {
            state.gorunum = gorunumDogrula(action.payload);
            Object.assign(state, turetilmis(state.gorunum));
        },
    }
})

// menuFold yalnız tercihten türetilir (setMenuFold kaldırıldı: ikinci kaynak olmasın)
export const { setDirectionRTL, toggleCollapsedSideNav, updateWindowWidth, setFullScreen, setGorunum, gorunumYukle } = themeSlice.actions;

export default themeSlice.reducer;
